<template>
  <div class="profile" v-if="employee">
    <v-tabs
      v-model="tab"
      background-color="blue"
      center-active
      dark
      centered
      fixed-tabs
      slider-color="blue darken-3"
      slider-size="3"
    >
      <v-tab>Datos básicos</v-tab>
      <v-tab>Datos complementarios</v-tab>
      <v-tab>Documentos</v-tab>
      <v-tab>
        <v-badge
          color="green"
          :content="
            employee.user.notes.length > 0 ? employee.user.notes.length : '0'
          "
        >
          Notas
        </v-badge>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row class="text-left">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Nombre:</span>
                {{ employee.user.full_name }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Cédula:</span>
                {{ employee.user.colombian_id }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Ciudad de expedición:</span
                >
                {{ employee.expedition_city }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Teléfono:</span>
                {{ employee.user.phone }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Dirección:</span>
                {{ employee.user.address }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Correo:</span>
                {{ employee.user.email }}
              </v-col>
              <v-col cols="12" md="3">
                <v-chip
                  :color="getEmployeeStatuColor(employee.status)"
                  dark
                  small
                >
                  {{ getEmployeeStatus(employee.status) }}
                </v-chip>
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Puede Crear Cuenta De Cobro Sin Informe?:</span
                >
                {{ employee.can_create_bill_without_report ? "SI" : "NO" }}
              </v-col>
            </v-row>
            <v-row class="text-left" v-if="employee.charge_id">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Cargo:</span>
                {{ employee.charge.name }}
              </v-col>
            </v-row>
            <v-row class="text-left" v-if="employee.charge_id">
              <v-col cols="12" md="3" v-if="role == 'ADMINISTRATOR'">
                <v-btn small color="primary" rounded @click="createPassword">
                  Generar Contraseña
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              bottom
              right
              fixed
              color="green"
              v-bind="attrs"
              v-on="on"
              dark
              @click="editEmployee"
            >
              <v-icon>mdi-account-edit-outline</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row class="text-left">
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Tipo de sangre:</span
                >
                {{ employee.blood_type }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Fecha de nacimiento:</span
                >
                {{ employee.birthday }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold">Eps:</span>
                {{ employee.eps }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold">Pensión:</span>
                {{ employee.pension }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Operador de pila (seguridad social):</span
                >
                {{ employee.stack_operator }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Correo segundario:</span
                >
                {{ employee.second_email }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold">Teléfono fijo:</span>
                {{ employee.landline }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Nombre</th>
                    <th class="text-left">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">Foto</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.photo_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Propuesta</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.proposal_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Rut</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.rut_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Hoja de vida</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.cv_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Soportes de hoja de vida</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.cv_supports_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Cedula Legible</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.colombian_id_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Antecedentes Fiscales expedido por la
                      Contraloría General de la República
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          employee.certificate_criminal_records_by_comptroller_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Antecedentes Fiscales Expedido por la
                      Procuraduría General de la República
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          employee.certificate_criminal_records_by_attorney_office_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Consulta de antecedentes Policía Nacional
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          employee.certificate_criminal_records_by_police_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Consulta de Medidas correctivas expedido
                      por la Policía Nacional
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          employee.certificate_corrective_measures_by_police_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificación Bancaria Actualizada {{ new Date().getFullYear() }}
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.certificate_bank_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Examen Médico Ocupacional vigente {{ new Date().getFullYear() }}
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.medical_exams_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Afiliación a EPS vigente {{ new Date().getFullYear() }}
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.certificate_eps_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Afiliación a AFP (pensión)
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.certificate_afp_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Redam
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.certificate_redam_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Delitos sexuales
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="employee.certificate_sexual_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <note-show
          :notes="employee.user.notes"
          :owner="employee.user.id"
          type="PROFILE"
        ></note-show>
      </v-tab-item>
    </v-tabs-items>

    <!-- change charge dialog -->
    <v-dialog v-model="dialogEditEmployee" width="500" persistent>
      <v-card>
        <v-card-text class="py-4"> Editar Colaborador </v-card-text>

        <v-divider></v-divider>

        <v-card-text>
          <v-autocomplete
            :items="this.$store.state.charge.charges.charges"
            label="Cargo"
            v-model="model.charge_id"
            item-text="name"
            item-value="id"
          ></v-autocomplete>

          <v-select
            :items="this.$store.state.status.chargePermissions"
            v-model="model.can_create_bill_without_report"
            label="Puede Crear Cuenta De Cobro Sin Informe?"
            required
          ></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-4" small @click="editEmployeeSave">
            Confirmar
          </v-btn>

          <v-btn
            color="error"
            text
            class="mr-4"
            small
            @click="cancelEditEmployee"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
import { mapGetters } from "vuex";
import { SET_EMPLOYEE } from "@/store/employee";
import NoteShow from "@/components/note/Show";
export default {
  name: "ShowEmployee",
  components: {
    NoteShow,
  },
  data: () => ({
    tab: null,
    employee: null,
    dialogEditEmployee: false,
    model: {
      charge_id: null,
      can_create_bill_without_report: "",
    },
  }),
  created() {
    this.$store.dispatch("getChargesAll");
    this.$store.dispatch("getEmployee", this.$route.params.id);
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_EMPLOYEE) {
        this.employee = state.employee.employee;
      }
    });
  },
  computed: {
    ...mapGetters(["getEmployeeStatus", "getEmployeeStatuColor"]),
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
  },
  methods: {
    createPassword() {
      this.$store.dispatch("editEmployee", {
        id: this.employee.id,
        form: {
          _method: "put",
          password: "password",
        },
      });
    },
    editEmployee() {
      this.dialogEditEmployee = true;
    },
    cancelEditEmployee() {
      this.model = {
        charge_id: null,
        can_create_bill_without_report: "",
      };
      this.dialogEditEmployee = false;
    },
    editEmployeeSave() {
      //validate if added info
      if (!this.model.charge_id && !this.model.can_create_bill_without_report) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar algun campo para actualizar",
          type: "error",
        });
        return;
      }

      this.$store.dispatch("editEmployee", {
        id: this.employee.id,
        form: this.createFormData(),
      });
      this.dialogEditEmployee = false;
    },
    createFormData() {
      this.model._method = "put";
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (value) {
          formData.append(key, value);
        }
      });
      return formData;
    },
  },
};
</script>
<style scoped>
.profile {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
